import { Comment, Text, h, Suspense, Teleport, Fragment } from "vue";
const toNode = (v, attrs) => {
  if (!v) {
    return null;
  }
  if (!("type" in v) || v.type === Text || typeof v === "string") {
    return h("div", attrs, v);
  }
  if (v.type === Comment) {
    return v;
  }
  if ("$el" in v) {
    return toNode(v.$el, attrs);
  }
  if (v.type === Suspense) {
    return h(v.ssContent, attrs);
  }
  if (v.type === Teleport) {
    if (v.children === null) {
      return v;
    }
    const anchor = toNode(v.children[0], attrs);
    if (anchor) {
      v.children[0] = h(anchor, attrs);
    }
    return v;
  }
  if (v.type === Fragment) {
    if (v.children === null) {
      return v;
    }
    return toNode(v.children[0], attrs);
  }
  return h(v, attrs);
};
const renderSlotNode = (slot, slotBind = {}, nodeAttributes = {}) => {
  const children = slot == null ? void 0 : slot(slotBind);
  if (!children) {
    return null;
  }
  return toNode(children.find((v) => v.type !== Comment) || children[0], nodeAttributes);
};
const renderSlotNodes = (slot, slotBind = {}, nodeAttributes = {}) => {
  const children = slot == null ? void 0 : slot(slotBind);
  if (!children) {
    return null;
  }
  return children.map((v) => toNode(v, nodeAttributes));
};
export {
  renderSlotNodes as a,
  renderSlotNode as r
};
//# sourceMappingURL=headless-faf1071e.mjs.map
